export default __webpack_public_path__ + "static/media/word_icon.70132945.svg";